import { useState } from 'react'
import Table, { TableRow } from '../../../../../common/components/molecule/Table/Table'
import ConfirmationModal from '../../../../../common/components/atom/ConfirmationModal/ConfirmationModal'
import RowActions from '../../../../../common/components/atom/RowActions'
import { Luminaire } from '../../../../../features/luminaire/types/luminaire.types'
import { ResponseAPIWithPagination } from '../../../../../common/types/API.types'
import { useLuminaires, useDeleteLuminaire } from '../../../../../features/luminaire/hooks/useLuminaires'
import { useToast } from '../../../../../common/providers/ToastProvider/useToast'
import EditZhagaNodeDialog from '../EditZhagaNodeDialog/EditZhagaNodeDialog'

export default function ZhagaNodeList() {
  const { luminairesQuery } = useLuminaires()
  const deleteLuminaire = useDeleteLuminaire()
  const toast = useToast()

  const [deleteTarget, setDeleteTarget] = useState<Luminaire | null>(null)
  const [editTarget, setEditTarget] = useState<Luminaire | null>(null)

  const luminaires: Luminaire[] =
    (luminairesQuery.data as ResponseAPIWithPagination<Luminaire> | undefined)?.data ?? []

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return
    deleteLuminaire.mutate({
      lumId: deleteTarget.lum_id,
      callbackFunc: ({ error }) => {
        if (error) {
          toast.error(
            error?.response?.data?.message ?? 'Erreur lors de la suppression'
          )
        } else {
          toast.success('Luminaire supprimé')
        }
        setDeleteTarget(null)
      },
    })
  }

  const bodyData: TableRow[] = luminaires.map((lum) => ({
    id: lum.lum_id,
    data: [
      lum.lum_name,
      lum.lum_pole_number,
      lum.lum_phase_number,
      lum.lum_dev_eui,
      <RowActions
        key={`actions-${lum.lum_id}`}
        onEdit={() => setEditTarget(lum)}
        onDelete={() => setDeleteTarget(lum)}
      />,
    ],
  }))

  const emptyMessage = luminairesQuery.isError
    ? 'Impossible de charger les luminaires'
    : 'Aucun nœud Zhaga enregistré'

  return (
    <>
      <Table
        headerTitle={['Nom', 'Poteau', 'Phase', 'devEUI', '']}
        bodyData={luminairesQuery.isError ? [] : bodyData}
        isLoading={luminairesQuery.isLoading}
        emptyMessage={emptyMessage}
      />

      <EditZhagaNodeDialog
        open={!!editTarget}
        luminaire={editTarget}
        onClose={() => setEditTarget(null)}
      />

      <ConfirmationModal
        isOpen={!!deleteTarget}
        type="danger"
        title="Supprimer ce luminaire ?"
        message={deleteTarget ? `Supprimer « ${deleteTarget.lum_name} » ?` : ''}
        confirmText="Supprimer"
        cancelText="Annuler"
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteTarget(null)}
      />
    </>
  )
}
